import { render, staticRenderFns } from "./Compartilhamento.vue?vue&type=template&id=277947e0&"
import script from "./Compartilhamento.vue?vue&type=script&lang=js&"
export * from "./Compartilhamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports